export const FILTER_ICON = ({ width = '16', height = '17' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 17"
      fill="none"
    >
      <path
        d="M2.00326 8.49666C2.00326 9.23304 2.60021 9.83 3.33659 9.83C4.07297 9.83 4.66992 9.23304 4.66992 8.49666C4.66992 7.76028 4.07297 7.16333 3.33659 7.16333C2.60021 7.16333 2.00326 7.76028 2.00326 8.49666Z"
        stroke="#787878"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M7.33333 3.83333C7.33333 4.56971 7.93029 5.16667 8.66667 5.16667C9.40305 5.16667 10 4.56971 10 3.83333C10 3.09695 9.40305 2.5 8.66667 2.5C7.93029 2.5 7.33333 3.09695 7.33333 3.83333Z"
        stroke="#787878"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M11.9998 13.1666C11.9998 13.903 12.5968 14.4999 13.3332 14.4999C14.0696 14.4999 14.6665 13.903 14.6665 13.1666C14.6665 12.4302 14.0696 11.8333 13.3332 11.8333C12.5968 11.8333 11.9998 12.4302 11.9998 13.1666Z"
        stroke="#787878"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.33691 2.5L3.33691 6.46667"
        stroke="#787878"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M3.33691 10.5L3.33691 14.4667"
        stroke="#787878"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.6665 5.83325L8.6665 14.4999"
        stroke="#787878"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M13.3335 2.5L13.3335 11.1667"
        stroke="#787878"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  )
}

export const REPO_ICON = ({ width = '18', height = '18' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 60 60">
      <defs>
        <style>{`
.cls-1 { fill: none; }
.cls-2 { fill: #3d3d63; }
`}
        </style>
      </defs>
      <title />
      <g data-name="Layer 2" id="Layer_2">
        <g id="Icons">
          <g id="Folder">
            <rect class="cls-1" height="60" width="60" />
            <path class="cls-2" d="M46.27,32.49h-.05l1.92-21.88A2.34,2.34,0,0,0,46,8.08L18.55,5.68A2.35,2.35,0,0,0,16,7.8l-.25,2.91H13.55A2.33,2.33,0,0,0,11.22,13V50.43a2.33,2.33,0,0,0,2.33,2.33h4a2.53,2.53,0,0,0,2.33,1.57H46.27a2.52,2.52,0,0,0,2.51-2.51V35A2.52,2.52,0,0,0,46.27,32.49ZM18,8a.33.33,0,0,1,.36-.3l27.46,2.4a.33.33,0,0,1,.3.36L44.21,32.49h-.76V13a2.33,2.33,0,0,0-2.33-2.33H17.78Zm-.68,31.57V50.76H13.55a.33.33,0,0,1-.33-.33V13a.33.33,0,0,1,.33-.33H41.12a.33.33,0,0,1,.33.33V32.49H36.74a4,4,0,0,0-2.5.88l-4.05,3.22a2,2,0,0,1-1.26.44H19.85A2.51,2.51,0,0,0,17.34,39.54ZM46.78,51.82a.51.51,0,0,1-.51.51H19.85a.51.51,0,0,1-.51-.51V39.54a.51.51,0,0,1,.51-.51h9.08a4,4,0,0,0,2.51-.88l4-3.22a2.07,2.07,0,0,1,1.26-.44h9.53a.51.51,0,0,1,.51.51Z" />
            <path class="cls-2" d="M43.64,48.27H39.87a1,1,0,0,0,0,2h3.77a1,1,0,0,0,0-2Z" />
            <path class="cls-2" d="M24.7,18.12H30a1,1,0,0,0,0-2H24.7a1,1,0,0,0,0,2Z" />
            <path class="cls-2" d="M19,23.79H35.64a1,1,0,0,0,0-2H19a1,1,0,0,0,0,2Z" />
            <path class="cls-2" d="M36.64,27.83a1,1,0,0,0-1-1H19a1,1,0,0,0,0,2H35.64A1,1,0,0,0,36.64,27.83Z" />
          </g>
        </g>
      </g>
    </svg>
  )
}